"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncConfigurationSettingsContainer = AsyncConfigurationSettingsContainer;
exports.AsyncDoubleOptInSettingsContainer = AsyncDoubleOptInSettingsContainer;
exports.AsyncSmtpSettingsContainer = AsyncSmtpSettingsContainer;
exports.AsyncSubscriptionsSettingsContainer = AsyncSubscriptionsSettingsContainer;
exports.AsyncTrackingSettingsContainer = AsyncTrackingSettingsContainer;
exports.AsyncTypeSettingsContainer = AsyncTypeSettingsContainer;
exports.AsyncSendFrequencyContainer = AsyncSendFrequencyContainer;

var _react = _interopRequireDefault(require("react"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var ConfigurationSettingsContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/ConfigurationSettingsContainer'
    /* webpackChunkName: "chunk-marketing-email" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncConfigurationSettingsContainer(props) {
  return _react.default.createElement(ConfigurationSettingsContainer, props);
}

var DoubleOptInSettingsContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/DoubleOptInSettingsContainer'
    /* webpackChunkName: "chunk-marketing-email" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncDoubleOptInSettingsContainer(props) {
  return _react.default.createElement(DoubleOptInSettingsContainer, props);
}

var SmtpSettingsContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/SmtpSettingsContainer'
    /* webpackChunkName: "chunk-marketing-email" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncSmtpSettingsContainer(props) {
  return _react.default.createElement(SmtpSettingsContainer, props);
}

var SubscriptionsSettingsContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/SubscriptionsSettingsContainer'
    /* webpackChunkName: "chunk-marketing-email" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncSubscriptionsSettingsContainer(props) {
  return _react.default.createElement(SubscriptionsSettingsContainer, props);
}

var TrackingSettingsContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/TrackingSettingsContainer'
    /* webpackChunkName: "chunk-marketing-email" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncTrackingSettingsContainer(props) {
  return _react.default.createElement(TrackingSettingsContainer, props);
}

var TypeSettingsContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/TypeSettingsContainer'
    /* webpackChunkName: "chunk-marketing-email" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncTypeSettingsContainer(props) {
  return _react.default.createElement(TypeSettingsContainer, props);
}

var SendFrequencyContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/SendFrequencyContainer'
    /* webpackChunkName: "chunk-marketing-email" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncSendFrequencyContainer(props) {
  return _react.default.createElement(SendFrequencyContainer, props);
}